<template>
  <div :class="containerClassName">
    <slot name="label" :id="id" :label="label" :required="required">
      <label :for="id" v-if="!hideLabel">{{label}}<span v-if="required"> *</span></label>
    </slot>
    <div class="select-container" :class="{'form-error': errors.has(name), 'disabled': isDisabled}">
      <select :value="modelValue" :id="id" :name="name" :disabled="isDisabled" @change="onChange">
        <option v-for="option in options" v-bind:value="option.key" v-bind:key="option.key" :disabled="option.disabled || (disableOptionOnEmpty && !option.key)">
          <slot name="option" :option="option">
            {{option.val}}
            <span v-if="option.key && option.val !== 'Laster...'">[{{option.key}}]</span>
          </slot>
        </option>
      </select>
      <span class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-select"></use></svg></span>
      <span class="form-error-label" v-if="errors.has(name)">
        <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
        {{ customErrorMessage ? customErrorMessage : errors.first(name) }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheCountryInput',
  inject: [
    '$validator'
  ],
  model: {
    prop: 'modelValue',
    event: 'input'
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    customErrorMessage: {
      type: String,
      default: ''
    },
    containerClassName: {
      type: String,
      default: 'cell large-12'
    },
    id: {
      type: String,
      default: function () {
        return 'input-id-' + this._uid
      }
    },
    name: {
      type: String,
      default: null
    },
    modelValue: {
      type: [String, Number, Array, Object],
      default: undefined
    },
    disabled: {
      type: [Boolean, Number],
      default: false
    },
    disableOnOptionLength: {
      type: [String, Number],
      default: null
    },
    disableOptionOnEmpty: {
      type: [Boolean, Number],
      default: false
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    required: {
      type: [Boolean, Number],
      default: false
    },
    items: {
      type: Array,
      default: function () {
        return []
      }
    },
    onLoadCallback: {
      type: Function,
      required: false
    },
    model: {}
  },
  data () {
    return {
      options: []
    }
  },
  created () {
    if (this.items) {
      this.options = this._.clone(this.items)
    }

    this.fetch()
  },
  watch: {
    items: function () {
      this.options = this._.clone(this.items)
    }
  },
  computed: {
    isDisabled: function () {
      return this.disabled || (this.disableOnOptionLength !== null && this.options.length <= this.disableOnOptionLength)
    }
  },
  methods: {
    fetch () {
      if (this.onLoadCallback !== undefined) {
        this.onLoadCallback()
          .then((data) => {
            this.options = data.data
          })
          .catch((error) => {
            console.log('Error', error)
          })
      }
    },
    onChange (e) {
      this.$emit('input', e.target.value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Inputs/TheCountryInput.vue